export enum LocationDataTestIdEnum {
  LOCATION_RESULT_OPTION = 'result-location--option',
  LOCATION_RESULT_SEARCH = 'location-search-results',
  LOCATION_RECENT_SEARCHED_RESULTS = 'recent-searched-results',
  LOCATION_RECENT_SEARCHED_RESULTS_CLEAR = 'recent-searched-results-clear',
  LOCATION_RECENT_SEARCHED_RESULTS_CONTAINER = 'recent-searched-results-container',
  LOCATION_SELECTION_MODAL = 'location-selection-modal',
  LOCATION_SELECTION_MODAL_CLOSE_BUTTON = 'location-selection-modal-close-button',
}
